module.exports = __webpack_public_path__ + "img/groups.0cdf1fc6.svg";